/**
 * File types a tracker source may be uploaded as (PREC-3240). The API reads the first sheet with
 * SheetJS (`parseAndTrimXlsx`), which takes all three; the picker used to accept `.xlsx` only, so a
 * CSV or legacy Excel export was refused before it was ever sent.
 */
export const TRACKER_UPLOAD_FILE_TYPES = ["xlsx", "xls", "csv"];
